import { createSvgIcon } from '@mui/material';

const ConnectIcon = (props) => {
  const IconCmp = createSvgIcon(
    <>
      <path
        d="M1 1V6.5C1 7.90013 1 8.6002 1.27248 9.13498C1.51217 9.60538 1.89462 9.98783 2.36502 10.2275C2.8998 10.5 3.59987 10.5 5 10.5H8M8 10.5C8 11.8807 9.11929 13 10.5 13C11.8807 13 13 11.8807 13 10.5C13 9.11929 11.8807 8 10.5 8C9.11929 8 8 9.11929 8 10.5Z"
        stroke="#4E48FA"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </>,
    'ConnectIcon',
  );
  return (
    <IconCmp
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      style={{ fill: 'none' }}
      {...props}
    />
  );
};
export default ConnectIcon;
